import { render, staticRenderFns } from "./certification-progress.vue?vue&type=template&id=2dad4d9a&scoped=true&"
import script from "./certification-progress.vue?vue&type=script&lang=js&"
export * from "./certification-progress.vue?vue&type=script&lang=js&"
import style0 from "./certification-progress.vue?vue&type=style&index=0&id=2dad4d9a&lang=less&scoped=true&"
import style1 from "./certification-progress.vue?vue&type=style&index=1&id=2dad4d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad4d9a",
  null
  
)

export default component.exports